import { render, staticRenderFns } from "./Reason.vue?vue&type=template&id=437278fc&scoped=true&"
import script from "./Reason.vue?vue&type=script&lang=js&"
export * from "./Reason.vue?vue&type=script&lang=js&"
import style0 from "./Reason.vue?vue&type=style&index=0&id=437278fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437278fc",
  null
  
)

export default component.exports